document.addEventListener('DOMContentLoaded', async function () {
  const viewer = document.getElementById('drive-media-viewer');
  const feedUrl = viewer.getAttribute('data-feed');

  let mediaData = [];
  const spinner = document.querySelector('.spinner-overlay');

  try {
    spinner.style.display = 'flex';
    console.log('Loading from:', feedUrl);

    const response = await fetch(feedUrl, {
      method: 'GET',
      headers: {
        'Accept': 'text/plain'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    const responseText = await response.text();
    console.log('Raw response length:', responseText.length);
    
    mediaData = parseNDJSON(responseText);

    if (mediaData.length === 0) {
      throw new Error('No data found in feed');
    }

    console.log(`✅ Loaded ${mediaData.length} media items from Plytix NDJSON feed`);

    initializeBrandFolders(mediaData);
    initializeFilters(mediaData);
    displayBrandFolders(mediaData);

    spinner.style.display = 'none';

  } catch (error) {
    console.error('Error loading feed:', error);
    spinner.style.display = 'none';
    showError('Failed to load media from Plytix: ' + error.message);
  }

  document.getElementById('back-to-folders').addEventListener('click', () => {
    document.getElementById('brand-folders-container').classList.remove('hidden');
    document.getElementById('drive-media-container').classList.add('hidden');
    document.getElementById('back-to-folders').classList.add('hidden');
    document.getElementById('current-brand').classList.add('hidden');
    document.querySelector('.media-zip-controls').classList.add('hidden');
  });
});

function parseNDJSON(ndjsonText) {
  const mediaItems = [];
  const lines = ndjsonText.trim().split('\n');
  
  lines.forEach((line, lineIndex) => {
    if (!line.trim()) return;

    try {
      const product = JSON.parse(line);
      const sku = product.SKU || product.sku || '';
      const brandName = product['Brand Name'] || product.brand || product.brandName || '';
      const productGallery = product['Product Gallery'] || product.gallery || product.images || [];

      const galleryArray = Array.isArray(productGallery) 
        ? productGallery 
        : (productGallery ? [productGallery] : []);

      galleryArray.forEach((imageUrl, imageIndex) => {
        if (imageUrl && typeof imageUrl === 'string') {
          mediaItems.push({
            id: `${sku}-${imageIndex}`,
            sku: sku,
            brand: brandName,
            collection: brandName,
            name: `${sku}-img-${imageIndex}`,
            url: imageUrl,
            type: getMediaType(imageUrl),
            thumbnail: imageUrl,
            product_index: lineIndex,
            image_index: imageIndex
          });
        }
      });
    } catch (error) {
      console.warn(`Could not parse line ${lineIndex}:`, error);
    }
  });

  return mediaItems;
}

function getMediaType(url) {
  const videoExtensions = ['mp4', 'webm', 'avi', 'mov', 'mkv', 'flv'];
  const ext = url.split('.').pop().split('?')[0].toLowerCase();
  return videoExtensions.includes(ext) ? 'video' : 'image';
}

function initializeBrandFolders(mediaData) {
  const brands = [...new Set(mediaData.map(item => item.brand).filter(Boolean))].sort();
  window.allBrands = brands;
}

function displayBrandFolders(mediaData) {
  const container = document.getElementById('brand-folders-container');
  container.innerHTML = '';

  const brands = [...new Set(mediaData.map(item => item.brand).filter(Boolean))].sort();

  brands.forEach(brand => {
    const brandCount = mediaData.filter(item => item.brand === brand).length;
    const folderDiv = document.createElement('div');
    folderDiv.className = 'brand-folder';
    folderDiv.innerHTML = `
      <div class="folder-icon">📁</div>
      <div class="folder-name">${brand}</div>
      <div class="folder-count">${brandCount} items</div>
    `;

    folderDiv.addEventListener('click', () => {
      const filtered = mediaData.filter(item => item.brand === brand);
      displayMediaForBrand(filtered, brand);
    });

    container.appendChild(folderDiv);
  });
}

function displayMediaForBrand(mediaData, brandName) {
  document.getElementById('brand-folders-container').classList.add('hidden');
  document.getElementById('drive-media-container').classList.remove('hidden');
  document.getElementById('back-to-folders').classList.remove('hidden');
  document.getElementById('current-brand').classList.remove('hidden');
  document.getElementById('breadcrumb-brand-name').textContent = brandName;
  document.querySelector('.media-zip-controls').classList.remove('hidden');

  const container = document.getElementById('drive-media-container');
  container.innerHTML = '';

  mediaData.forEach((media, index) => {
    const mediaItem = document.createElement('div');
    mediaItem.className = 'media-item';
    mediaItem.innerHTML = `
      <div class="media-checkbox-wrapper">
        <input type="checkbox" class="media-checkbox" data-url="${media.url}" data-name="${media.sku}" data-brand="${media.brand}" />
      </div>
      <div class="media-thumb">
        <img src="${media.thumbnail}" alt="${media.sku}" class="media-thumbnail-img" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22200%22 height=%22200%22%3E%3Crect fill=%22%23e0e0e0%22 width=%22200%22 height=%22200%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-family=%22sans-serif%22 font-size=%2214%22 fill=%22%23999%22%3ENo image%3C/text%3E%3C/svg%3E'">
      </div>
      <div class="media-info">
        <p class="media-brand">${media.brand}</p>
        <p class="media-sku">${media.sku}</p>
      </div>
    `;

    mediaItem.addEventListener('click', (e) => {
      if (e.target.classList.contains('media-checkbox') || e.target.closest('.media-checkbox-wrapper')) {
        return;
      }
      openPreview(mediaData, index);
    });

    container.appendChild(mediaItem);
  });
}

function initializeFilters(mediaData) {
  const brandSelect = document.querySelector('select[name="brand"]');
  const brands = [...new Set(mediaData.map(item => item.brand).filter(Boolean))].sort();
  
  brands.forEach(brand => {
    const option = document.createElement('option');
    option.value = brand;
    option.textContent = brand;
    brandSelect.appendChild(option);
  });

  document.getElementById('drive-filter-form').addEventListener('submit', (e) => {
    e.preventDefault();
    filterAndDisplay(mediaData);
  });

  const skuInput = document.querySelector('input[name="sku"]');
  skuInput.addEventListener('input', () => {
    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => filterAndDisplay(mediaData), 300);
  });

  document.querySelector('select[name="brand"]').addEventListener('change', () => filterAndDisplay(mediaData));

  const selectAllCheckbox = document.getElementById('drive-select-all');
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', toggleSelectAll);
  }
}

function filterAndDisplay(mediaData) {
  const sku = document.querySelector('input[name="sku"]').value.toLowerCase().trim();
  const brand = document.querySelector('select[name="brand"]').value;

  const filtered = mediaData.filter(item => {
    const skuMatch = !sku || item.sku.toLowerCase().includes(sku);
    const brandMatch = !brand || item.brand === brand;
    return skuMatch && brandMatch;
  });

  if (filtered.length === 0) {
    document.getElementById('drive-no-results').classList.remove('hidden');
    document.getElementById('drive-media-container').classList.add('hidden');
    document.querySelector('.media-zip-controls').classList.add('hidden');
  } else {
    document.getElementById('drive-no-results').classList.add('hidden');
    displayMediaForBrand(filtered, brand || 'All Brands');
  }
}

function openPreview(mediaData, startIndex) {
  const modal = document.getElementById('image-preview-modal');
  let currentIndex = startIndex;

  function updatePreview() {
    const media = mediaData[currentIndex];
    const imgPreview = document.getElementById('image-preview');
    const videoPreview = document.getElementById('video-preview');

    if (media.type === 'video') {
      imgPreview.style.display = 'none';
      videoPreview.style.display = 'block';
      videoPreview.src = media.url;
    } else {
      imgPreview.style.display = 'block';
      videoPreview.style.display = 'none';
      imgPreview.src = media.url;
    }

    document.querySelector('.media-preview-info')?.remove();
    const info = document.createElement('div');
    info.className = 'media-preview-info';
    info.innerHTML = `<p><strong>SKU:</strong> ${media.sku}</p><p><strong>Brand:</strong> ${media.brand}</p><p>${currentIndex + 1} / ${mediaData.length}</p>`;
    modal.appendChild(info);
  }

  document.getElementById('prev-image').onclick = () => {
    currentIndex = (currentIndex - 1 + mediaData.length) % mediaData.length;
    updatePreview();
  };

  document.getElementById('next-image').onclick = () => {
    currentIndex = (currentIndex + 1) % mediaData.length;
    updatePreview();
  };

  document.querySelector('.image-modal-close').onclick = () => {
    modal.classList.add('hidden');
  };

  updatePreview();
  modal.classList.remove('hidden');
}

document.getElementById('drive-download-zip')?.addEventListener('click', async function () {
  const selected = document.querySelectorAll('.media-checkbox:checked');
  if (selected.length === 0) {
    alert('Please select media to download');
    return;
  }

  const spinner = document.querySelector('.spinner-overlay');
  spinner.style.display = 'flex';

  const zip = new JSZip();
  let successCount = 0;

  for (const checkbox of selected) {
    const url = checkbox.getAttribute('data-url');
    const sku = checkbox.getAttribute('data-name');
    const brand = checkbox.getAttribute('data-brand');

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const ext = url.split('.').pop().split('?')[0];
      zip.file(`${brand}/${sku}-${Date.now()}.${ext}`, blob);
      successCount++;
    } catch (error) {
      console.error(`Failed to download ${sku}:`, error);
    }
  }

  try {
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, `plytix-media-${new Date().toISOString().split('T')[0]}.zip`);
    alert(`Downloaded ${successCount} files`);
  } catch (error) {
    alert('Failed to create ZIP file');
  }

  spinner.style.display = 'none';
});

function toggleSelectAll() {
  const selectAll = document.getElementById('drive-select-all');
  const checkboxes = document.querySelectorAll('.media-checkbox');
  checkboxes.forEach(checkbox => {
    checkbox.checked = selectAll.checked;
  });
}

function showError(message) {
  const container = document.getElementById('brand-folders-container');
  container.innerHTML = `<div class="error-message"><p style="color: red; padding: 20px; text-align: center;">${message}</p></div>`;
}